export function searchToObject(search: string): object & any {
  // tslint:disable-next-line:prefer-const
  const pairs = search.substring(1).split('&');
  const obj = {};
  let pair;

  for (const i in pairs) {
    if (pairs[i] === '') {
      continue;
    }
    pair = pairs[i].split('=');
    (obj as any)[decodeURIComponent(pair[0] as any) as any] = decodeURIComponent(pair[1]);
  }

  return obj;
}

export const search = searchToObject(window.location.search);
